"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LinkedIn = function LinkedIn(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.833 1.936A1.532 1.532 0 0 1 2.365.404h15.268a1.531 1.531 0 0 1 1.534 1.532v15.268a1.53 1.53 0 0 1-1.533 1.533H2.365a1.532 1.532 0 0 1-1.532-1.532V1.935ZM8.09 7.394h2.482V8.64c.359-.717 1.276-1.362 2.653-1.362 2.64 0 3.267 1.427 3.267 4.047v4.851h-2.673v-4.255c0-1.491-.358-2.333-1.268-2.333-1.263 0-1.788.907-1.788 2.333v4.255H8.09V7.394Zm-4.583 8.67H6.18V7.278H3.507V16.063Zm3.055-11.65a1.72 1.72 0 1 1-3.437.076 1.72 1.72 0 0 1 3.437-.076Z",
    fill: color
  }));
};
var _default = exports["default"] = LinkedIn;